import * as React from "react";

type TextInputProps = {
  id?: string;
  label?: React.ReactNode;
  type?: React.HTMLInputTypeAttribute;
  placeholder?: string;
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  name?: string;
  autoComplete?: string;
  required?: boolean;
  error?: React.ReactNode;
  className?: string;
  inputClassName?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
};

export default function TextInput({
  id,
  label,
  type = "text",
  placeholder,
  value,
  onChange,
  name,
  autoComplete,
  required,
  error,
  className = "",
  inputClassName = "",
  style,
  disabled = false,
}: TextInputProps) {
  return (
    <div className={`pis-field ${className}`.trim()}>
      {label ? (
        <label className="pis-label" htmlFor={id}>
          {label}
        </label>
      ) : null}
      <input
        id={id}
        name={name}
        className={`pis-input ${inputClassName}`.trim()}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        required={required}
        style={style}
        disabled={disabled}
      />
      {error ? (
        <div
          className="pis-inputError"
          style={{ color: "#dc3545", marginTop: 6, fontSize: 12 }}
          role="alert"
        >
          {error}
        </div>
      ) : null}
    </div>
  );
}
